import { defineMessages } from 'react-intl';

export default defineMessages({
  mattressRemovalTooltipParagraph1: {
    id: 'ShippingMethodForProducts.mattressRemovalTooltipParagraph1',
    description: 'Free Mattress Removal Tooltip Paragraph 1',
    defaultMessage:
      'We’ll take your old mattress away and responsibly dispose of it.',
  },
  mattressRemovalTooltipParagraph2: {
    id: 'ShippingMethodForProducts.mattressRemovalTooltipParagraph2',
    description: 'Free Mattress Removal Tooltip Paragraph 2',
    defaultMessage: 'Note: This removal does not include box springs or bases.',
  },
  freeMattressRemovalIncluded: {
    id: 'ShippingMethodForProducts.freeMattressRemovalIncluded',
    description: 'Free Mattress Removal incuded text',
    defaultMessage: 'Free mattress removal included.',
  },
  offerRemoval: {
    id: 'ShippingMethodForProducts.offerRemoval',
    description: 'Offer removal text',
    defaultMessage:
      'We’ll take your old mattress away and responsibly dispose of it. Note: This removal does not include box springs or bases.',
  },
  loeMsg: {
    id: 'ShippingMethodForProducts.loeMsg',
    description: 'LOE Message for mattresses and standard shipping',
    defaultMessage:
      'You will need at least 2 people to help set up your mattress. Our mattresses range from 105-279 lbs.',
  },
  removeOldMattress: {
    id: 'ShippingMethodForProducts.removeOldMattress',
    description: 'Remove old mattress text',
    defaultMessage: 'Remove Old Mattress',
  },

  productQuantityLabel: {
    id: 'ShippingMethodForProducts.productQuantityLabel',
    description: 'Label for product quantity',
    defaultMessage: 'Qty: {quantity}',
  },
  free: {
    id: 'ShippingMethodForProducts.free',
    description: 'Free text',
    defaultMessage: 'Free',
  },
  freeHomeSetupOff: {
    id: 'ShippingMethodForProducts.freeHomeSetupOff',
    description: '$200 off',
    defaultMessage: '$200.00',
  },
});
